import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { DeleteIconComponent } from '@itero/ui-toolkit-angular/icons';

import { ArtTreatmentListItem } from '../../models';
import { RxIntuitiveArtIndicationButtonComponent } from '../treatment-buttons/rx-intuitive-art-indication-button/rx-intuitive-art-indication-button.component';

@Component({
	selector: 'rx-intuitive-art-treatment-viewlist-item',
	templateUrl: './rx-intuitive-art-treatment-viewlist-item.component.html',
	styleUrls: ['./rx-intuitive-art-treatment-viewlist-item.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, TlkButtonComponent, DeleteIconComponent, RxIntuitiveArtIndicationButtonComponent]
})
export class RxIntuitiveArtTreatmentViewlistItemComponent {
	@Input() item!: ArtTreatmentListItem;
	@Input() chartReadOnly = false;
	@Output() readonly resetRequested = new EventEmitter<number>();

	onResetClicked(event: MouseEvent): void {
		event.stopPropagation();
		this.resetRequested.emit(this.item.toothId);
	}
}
